module.exports = __webpack_public_path__ + "static/media/email.1de8ad37.svg";